module.exports = __webpack_public_path__ + "img/a4dcb71.svg";